import Controller from '../utilities/layout-editor-base-controller';
import Client from '../utilities/layouts/client';
import Renderer from '../utilities/layouts/renderer';
import $ from 'jquery';


export default class extends Controller {
  static targets = this.targets.push(
    'sectionsTab',
    'landmarksTab'
  )

  connect() {
    const canvasSize = { height: 50, width: 1200 }
    this.loadLayout(Client, Renderer, true, canvasSize);
    window.addEventListener('position-selected', this.positionSelected);
  }

  positionSelected(event) {
    let { position } = event.detail;
    let positionHtmlID = `#${position.identifier}`

    $('html, body').animate({
      scrollTop: $(positionHtmlID).offset().top
    }, 1000);

    $(positionHtmlID).addClass('highlighted');

    setTimeout(function () {
      $(positionHtmlID).removeClass('highlighted');
    }, 4000);
  }
}
